__turbopack_context__.v({
  "spotlightAction": "action-item-module__M7MCLG__spotlightAction",
});
